export default __webpack_public_path__ + "static/drip-coffee-18854e99db04b27e9caa41d8b4c42d35.jpg";